import React, { Suspense } from 'react';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';
import doCopy from 'copy-to-clipboard';
import { xonokai } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { Button, MessagePlugin } from 'tdesign-react';
import { CopyIcon } from 'tdesign-icons-react';
import { useNavigate } from 'react-router-dom';
import { isVoid } from '@/utils/common';
import { doBuried } from '@/services/buriedService';

const SyntaxHighlighter = React.lazy(() => import('react-syntax-highlighter/dist/esm/prism'));

// http 或者 // 开头则打开新窗口
function LinkRenderer(props) {
  const navigate = useNavigate();
  const { href, children } = props;

  const goPage = (e) => {
    e.preventDefault();
    navigate(href);
  };

  if (href.startsWith('http') || href.startsWith('//')) {
    return (
      <a href={href} rel='noreferrer' target='_blank'>
        {children}
      </a>
    );
  }

  return (
    <a href='' onClick={goPage}>
      {children}
    </a>
  );
}

function Code({ node, inline, className, children, ...props }) {
  const match = /language-(\w+)~?(\w+)?/.exec(className || '');
  return !inline && match ? (
    <Suspense fallback={<div></div>}>
      <Container>
        <Button
          className='copy-icon'
          icon={<CopyIcon />}
          theme='default'
          variant='outline'
          size='small'
          onClick={() => {
            doCopy(children);
            MessagePlugin.info('已拷贝');
            // 如果有埋点
            const eventId = match[2];
            if (!isVoid(eventId)) {
              doBuried({ eventId });
            }
          }}
        />
        <SyntaxHighlighter style={xonokai} language={match[1]} PreTag='div' {...props}>
          {String(children).replace(/\n$/, '')}
        </SyntaxHighlighter>
      </Container>
    </Suspense>
  ) : (
    <code className={className} {...props}>
      {children}
    </code>
  );
}

export default function Markdown({ content, components, ...others }) {
  return (
    <MDWrap {...others}>
      <ReactMarkdown components={{ code: Code, a: LinkRenderer, ...components }}>
        {content}
      </ReactMarkdown>
    </MDWrap>
  );
}

const MDWrap = styled.div.attrs({ className: 'markdown-body' })`
  flex: 1;
  p {
    font: var(--td-font-body-medium);
    color: rgb(155, 162, 174);
    box-sizing: border-box;
    a[href] {
      display: inline-flex;
      cursor: pointer;
      align-items: center;
      position: relative;
      text-decoration: none;
      outline: none;
      padding: 0;
      transition: all 0.2s linear;
      font: var(--td-font-link-medium);
      color: var(--td-brand-color);
    }
    strong {
      color: initial;
    }
  }
`;

const Container = styled.div`
  position: relative;
  .copy-icon {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 1;
    cursor: pointer;
  }
`;
